import { GuestSelectors, UserSelectors } from '@core/account-data';
import { CandidateSelectors } from '@core/candidate-data';
import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  pipeState,
} from '@core/ngrx-legacy';
import { Note, RecentNotesFilters } from '@core/notes-types';

import { EntityStoreKey, RecentNotesParams } from '../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Note>()(
  EntityStoreKey.RecentNotes,
  {
    references: makeRef => [
      makeRef('adminId', 'admin', UserSelectors.byId),
      makeRef('guestId', 'guest', GuestSelectors.byId),
      makeRef('candidateId', 'candidate', candidateId => CandidateSelectors.byId(candidateId!)!),
    ],

    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, ({ id }) => id!);

      return {
        fetchRecentNotes: (
          state,
          payload: { scope: RecentNotesFilters; params: RecentNotesParams },
        ) =>
          pipeState(
            state,
            next => adapter.markAsPending(next, { scope: payload.scope, entities: [] }),
            next => defaultActions.fetchPaginatedCollection(next, payload),
          ),

        fetchRecentNotesSuccess: (state, payload) =>
          pipeState(
            state,
            next => adapter.addMany(next, payload.data.rows, { scope: payload.scope }),
            next => adapter.markAsLoaded(next, { scope: payload.scope, entities: [] }),
          ),
        fetchRecentNotesFailed: defaultActions.fetchPaginatedCollectionFailed,
      };
    },
  },
);

export {
  actions as RecentNotesActions,
  selectors as RecentNotesSelectors,
  namespace as RecentNotesNamespace,
  reducer as RecentNotesReducers,
};
